import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { HttpChargeBackService } from '@app/Modules/Shared/Services/http-charge-back.service';
import { MessageService } from 'primeng/api';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
var KcfileDownnloadComponent = /** @class */ (function () {
    function KcfileDownnloadComponent(httpServ, messageService, appServ) {
        this.httpServ = httpServ;
        this.messageService = messageService;
        this.appServ = appServ;
        this.subscription = new Subscription();
    }
    KcfileDownnloadComponent.prototype.agInit = function (params) {
        this.params = params;
    };
    KcfileDownnloadComponent.prototype.refresh = function (params) {
        return false;
    };
    KcfileDownnloadComponent.prototype.onKcfileNameClick = function () {
        var _this = this;
        this.appServ.setLoadingStatus(true);
        if (this.params.colDef.headerName == 'agGrid.agGridColumns.claimFileIDLabel') {
            this.params.data.kcFileID = this.params.data.claimFileID;
        }
        console.log(this.params.data, this.params.data.salesOrgId);
        if (this.params.data && this.params.data.kcFileID && this.params.data.salesOrgId) {
            var fileversion = (this.params.data.status && this.params.data.status == '3') ? 0 : 1;
            var request = {
                "claimFileId": this.params.data.kcFileID,
                "salesOrgId": this.params.data.salesOrgId,
                "fileversion": fileversion //passing fileversion as 1 as new file to be downloaded code is 1 and for old its 0
            };
            this.subscription.add(this.httpServ.kcfileDownload(request).subscribe(function (res) {
                if (res && res.fileUrl) {
                    window.open(res.fileUrl, '_blank');
                }
                else {
                    _this.messageService.add({ key: 'kcfileDownload', detail: 'An unexpected error occurred. Please try again.', summary: 'Error', severity: 'error' });
                }
            }, function (e) {
                _this.messageService.add({ key: 'kcfileDownload', detail: 'An unexpected error occurred. Please try again.', summary: 'Error', severity: 'error' });
            }, function () {
                _this.appServ.setLoadingStatus(false);
            }));
        }
    };
    KcfileDownnloadComponent.prototype.ngOnDestroy = function () {
        // Required for unsubscribing and destroying the component  
    };
    KcfileDownnloadComponent = tslib_1.__decorate([
        AutoUnsubscribe(),
        tslib_1.__metadata("design:paramtypes", [HttpChargeBackService,
            MessageService,
            AppService])
    ], KcfileDownnloadComponent);
    return KcfileDownnloadComponent;
}());
export { KcfileDownnloadComponent };
